// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../Config.bs.js";
import * as CrmNetwork from "../../../../../../library/network/CrmNetwork.bs.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as OrderDetailsMapRepoConfig from "./OrderDetailsMapRepoConfig.bs.js";

function fetchOrderMapData(order_id, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/api/orders/order_details/maps_data?order_id=" + order_id);
  return CrmNetwork.get(requestUrl, undefined, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(OrderDetailsMapRepoConfig.OrderDetailsMapResponseConverter.execute, result);
                        });
            });
}

var OrderDetailsMapRepo = {
  fetchOrderMapData: fetchOrderMapData
};

export {
  OrderDetailsMapRepo ,
  
}
/* Config Not a pure module */
